<template>
  <div class="container-login">
    <div class="container-dados">
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <div class="col-md-6 col-lg-5 text-center d-none d-md-block">
            <div class="logo-lecard"><img src="../assets/logo.png" alt="Logo LeCard"></div>
          </div>
          <div class="col-md-6 col-lg-5">
            <div class="card shadow-sm border mx-auto" style="max-width: 360px">
              <div class="card-body pb-4" >
                <div class="mb-4"><img src="../assets/logo.png" alt="Logo LeCard" style="width: 32px;"></div>
                <div v-if="step === 2">
                  <auth2 @voltar="step = 1" @auth="recuperar" :telefone="telefone" :error="error" :load="load"/>
                </div>
                <div v-else>
                  <div class="mb-3" v-if="step === 1">
                    <h5 class="mt-3 mb-1">Recuperar Senha</h5>
                    <div class="mb-0">Informe seu Usuário de acesso</div>
                  </div>
                  <div class="mb-3" v-else>Crie uma Senha forte com no mínimo 8 dígitos, incluindo letras e números.</div>
                  <div>
                    <form @submit.prevent="recuperar()">
                      <div class="form-group" v-if="step === 1">
                        <input type="email" id="usuario" v-model="dados.email" class="form-control" placeholder="Usuário ou E-mail" minlength="4" :disabled="load" required>
                      </div>
                      <div v-else>
                        <div class="form-group input-senha">
                          <input :type="showPassword === 1 ? 'text' : 'password'" id="inputSenha" class="form-control" v-model="dados.senha" placeholder="Senha" autocomplete="password" minlength="8" :disabled="load" required>
                          <i class="fa-solid" :class="showPassword === 1 ? 'fa-eye-slash' : 'fa-eye'" @click="mostrarSenha(1)" v-show="dados.senha.length > 0"
                             :title="showPassword === 1 ? 'Esconder Senha' : 'Mostrar Senha'"></i>
                        </div>
                        <div class="form-group input-senha">
                          <input :type="showPassword === 2 ? 'text' : 'password'" id="inputSenhaConfirm" class="form-control" v-model="senha_confirmar" placeholder="Confirme sua senha" autocomplete="password" minlength="8" :disabled="load" required>
                          <i class="fa-solid" :class="showPassword === 2 ? 'fa-eye-slash' : 'fa-eye'" @click="mostrarSenha(2)" v-show="senha_confirmar.length > 0"
                             :title="showPassword === 2 ? 'Esconder Senha' : 'Mostrar Senha'"></i>
                        </div>
                      </div>
                      <div class="alert-error small" v-if="error">{{ error }}</div>
                      <button class="btn btn-primary btn-block py-2" :disabled="load">{{load ? 'Aguarde' : 'Continuar'}}</button>
                      <div class="text-center mt-4">
                        <a href="javascript:" class="text-primary text-decoration-none" @click="voltar()">Voltar</a>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-botton text-white">
      <div class="container pb-3 text-center">
        <p class="m-0 small">&copy; {{ currentYear }} <b>LeCard</b>. Todos os direitos reservados.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../components/Loading";
import Auth2 from "@/components/Auth2";
import { TheMask } from 'vue-the-mask'

export default {
  name: 'Recuperar',
  components: {Auth2, Loading, TheMask},
  data() {
    return {
      load: false,
      showPassword: false,
      telefone: '',
      error: '',
      step: 1,
      senha_confirmar: '',
      sem_senha: false,
      dados: {
        pin: '',
        email: '',
        senha: ''
      }
    }
  },

  methods: {
    recuperar(pin) {
      this.error = "";

      switch (this.step) {
        case 1:
          this.dados.pin = "";
          this.dados.senha = "";
          break;

        case 2:
          this.dados.senha = "";
          this.dados.pin = pin || "";
          break;

        case 3:
          if (!this.dados.senha.trim() || this.senha_confirmar !== this.dados.senha) {
            this.error = "As senhas precisam ser iguais";
            return;
          }

          if (this.dados.senha.trim().length < 8) {
            this.error = "A senha precisa ter no mínimo 8 dígitos.";
            return;
          }

          break;
      }

      this.load = true;

      this.$http.post(this.base_server + 'auth/v2/recuperar', this.dados)
        .then(res => {
          this.load = false;
          const data = res.data || {};

          if (data.id_funcao && !['1','2','3'].includes(data.id_funcao)) {
            this.error = "Este usuário não tem acesso nesta plataforma!";
            this.load = false;
            return;
          }

          if (!data.success) {
            this.error = "Este usuário não tem acesso nesta plataforma!";

          } else if (this.step === 1) {
            this.telefone = data.telefone;
            this.step = data.sem_senha ? 3 : 2;

            this.$nextTick(() => {
              if (this.step === 3) {
                this.$helpers.focusElement('inputSenha');
              }
            });

          } else if (this.step === 2) {
            this.step = pin ? 3 : 2;
            this.$nextTick(() => {
              if (this.step === 3) {
                this.$helpers.focusElement('inputSenha');
              }
            });

          } else if (data.token) {
            this.load = true;
            localStorage.setItem("key", data.token);
            localStorage.setItem("email", this.dados.email);
            window.location.reload();
          }

        }, res => {
          this.load = false;
          const data = res.data || {};
          this.error = data.msg || 'Erro temporário';
        });
    },

    mostrarSenha(senha) {
      this.showPassword = this.showPassword === senha ? null : senha;
    },

    voltar() {
      this.error = '';

      if (this.step > 1) {
        this.step = 1;
        this.$nextTick(() => {
          this.$helpers.focusElement('usuario');
        })

      } else {
        this.$router.push('/');
      }
    }
  },

  mounted() {
    const recuperar = sessionStorage.getItem("recuperar");
    const sem_senha = sessionStorage.getItem("sem_senha");

    if (recuperar || sem_senha) {
      this.dados.email = recuperar || sem_senha;
      sessionStorage.removeItem('recuperar');
      sessionStorage.removeItem('sem_senha');

      if (sem_senha) {
        this.step = 3;
        this.$nextTick(() => {
          this.$helpers.focusElement('inputSenha');
        });

      } else {
        this.recuperar();
      }

    } else {
      this.$helpers.focusElement('usuario');
    }
  }
}
</script>

<style scoped>
.container-login {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  padding-top: var(--safe-area-inset-top, env(safe-area-inset-top, 0));
  padding-bottom: var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0));
}
.container-botton {
  width: 100%;
  flex: 0 0 auto;
}
.container-dados {
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 48px 0;
}
.logo-lecard img {
  width: 300px;
  object-fit: cover;
}

.dark-mode .logo-lecard img {
  filter: none;
}

.dark-mode .card-body > .mb-4 img {
  filter: none;
}

.text-primary {
  color: #6c8f1f !important;
}

.text-primary:hover,
.text-primary:focus {
  color: #5b7b17 !important;
}

.dark-mode .text-primary,
.dark-mode .text-primary:hover,
.dark-mode .text-primary:focus {
  color: var(--primary) !important;
}

.dark-mode img {
  filter: invert(100%);
}

@media (max-width: 767px) {
  .container-dados {
    padding-top: 0;
  }
}

@media (max-height: 550px) {
  .container-dados {
    padding: 48px 0;
  }
}
</style>
